<div class="dialog-header">
    <h2>Carga Masiva de Estatus</h2>
    <button mat-icon-button (click)="closeDialog()" [disabled]="isSaving">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="dialog-container">
    <div style="position: relative;">
        @if (isLoading || isSaving) {
        <div class="spinner-overlay">
            <mat-spinner diameter="40"></mat-spinner>
            <div class="spinner-text">{{ isSaving ? 'Guardando cambios...' : 'Procesando archivo...' }}</div>
        </div>
        }

        <!-- Steps bar -->
        <div class="steps-bar">
            <div class="step-item" [class.active]="step === 'upload'" [class.done]="step !== 'upload'"></div>
            <div class="step-item" [class.active]="step === 'preview'" [class.done]="step === 'result'"></div>
            <div class="step-item" [class.active]="step === 'result'"></div>
        </div>

        <!-- STEP 1: Upload -->
        @if (step === 'upload') {
        <div class="upload-zone" (click)="fileInput.click()" [class.has-file]="fileName">
            <mat-icon class="upload-icon">cloud_upload</mat-icon>
            <div class="upload-text">Selecciona el archivo Excel de cambios de estatus</div>
            <div class="upload-hint">Formato .xlsx — Folio Fiscal, Receptor RFC, Nuevo Estatus, Observaciones</div>
            @if (fileName) {
            <div class="file-name">{{ fileName }}</div>
            }
            <input #fileInput type="file" hidden accept=".xlsx" (change)="onFileSelected($event)">
        </div>

        <div class="template-row">
            <button mat-stroked-button color="primary" (click)="downloadTemplate()">
                <mat-icon>download</mat-icon> Descargar plantilla
            </button>
        </div>
        }

        <!-- STEP 2: Preview -->
        @if (step === 'preview') {
        <div>
            <!-- Summary cards -->
            <div class="summary-cards">
                <div class="summary-card total">
                    <div class="number">{{ totalRowsInFile }}</div>
                    <div class="label">Total en archivo</div>
                </div>
                <div class="summary-card valid">
                    <div class="number">{{ validDataSource.data.length }}</div>
                    <div class="label">Cambios válidos</div>
                </div>
                <div class="summary-card error">
                    <div class="number">{{ errorDataSource.data.length }}</div>
                    <div class="label">Con error</div>
                </div>
            </div>

            <!-- Tabs -->
            <div class="tab-bar">
                <button class="tab-btn" [class.active]="previewTab === 'valid'" (click)="onTabChange('valid')">
                    Válidos<span class="badge valid">{{ validDataSource.data.length }}</span>
                </button>
                <button class="tab-btn" [class.active]="previewTab === 'error'" (click)="onTabChange('error')">
                    Con error<span class="badge error">{{ errorDataSource.data.length }}</span>
                </button>
            </div>

            @if (previewTab === 'valid') {
            <div class="table-container">
                <div class="table-controls">
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Filtrar cambios válidos...</mat-label>
                        <input matInput (keyup)="applyFilter($event, validDataSource)" placeholder="Buscar...">
                    </mat-form-field>
                </div>
                <table mat-table [dataSource]="validDataSource">
                    <ng-container matColumnDef="folioFiscal">
                        <th mat-header-cell *matHeaderCellDef> Folio Fiscal (UUID) </th>
                        <td mat-cell *matCellDef="let row" [matTooltip]="row.folioFiscal"> {{row.folioFiscal}} </td>
                    </ng-container>
                    <ng-container matColumnDef="receptorRFC">
                        <th mat-header-cell *matHeaderCellDef> RFC Receptor </th>
                        <td mat-cell *matCellDef="let row"> {{row.receptorRFC}} </td>
                    </ng-container>
                    <ng-container matColumnDef="nuevoEstatus">
                        <th mat-header-cell *matHeaderCellDef> Nuevo Estatus </th>
                        <td mat-cell *matCellDef="let row"> {{row.nuevoEstatus}} </td>
                    </ng-container>
                    <ng-container matColumnDef="observaciones">
                        <th mat-header-cell *matHeaderCellDef> Observaciones </th>
                        <td mat-cell *matCellDef="let row" [matTooltip]="row.observaciones"> {{row.observaciones}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="validDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: validDisplayedColumns;"></tr>
                </table>
                <mat-paginator #validPaginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons>
                </mat-paginator>
            </div>
            }

            @if (previewTab === 'error') {
            <div>
                @if (errorDataSource.data.length > 0) {
                <div class="download-errors-row">
                    <button mat-stroked-button color="accent" (click)="downloadErrors($event)">
                        <mat-icon>download</mat-icon> Descargar errores
                    </button>
                </div>
                }
                <div class="table-container">
                    <div class="table-controls">
                        <mat-form-field appearance="outline" class="filter-field">
                            <mat-label>Filtrar errores...</mat-label>
                            <input matInput (keyup)="applyFilter($event, errorDataSource)" placeholder="Buscar...">
                        </mat-form-field>
                    </div>
                    <table mat-table [dataSource]="errorDataSource">
                        <ng-container matColumnDef="folioFiscal">
                            <th mat-header-cell *matHeaderCellDef> Folio Fiscal (UUID) </th>
                            <td mat-cell *matCellDef="let row" [matTooltip]="row.folioFiscal"> {{row.folioFiscal}} </td>
                        </ng-container>
                        <ng-container matColumnDef="receptorRFC">
                            <th mat-header-cell *matHeaderCellDef> RFC Receptor </th>
                            <td mat-cell *matCellDef="let row"> {{row.receptorRFC}} </td>
                        </ng-container>
                        <ng-container matColumnDef="nuevoEstatus">
                            <th mat-header-cell *matHeaderCellDef> Nuevo Estatus </th>
                            <td mat-cell *matCellDef="let row"> {{row.nuevoEstatus}} </td>
                        </ng-container>
                        <ng-container matColumnDef="errorReason">
                            <th mat-header-cell *matHeaderCellDef> Motivo del Error </th>
                            <td mat-cell *matCellDef="let row" class="error-cell"> {{row.errorReason}} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="errorDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: errorDisplayedColumns;"></tr>
                    </table>
                    <mat-paginator #errorPaginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
            }
        </div>
        }

        <!-- STEP 3: Result -->
        @if (step === 'result' && saveResult) {
        <div class="result-container">
            @if (saveResult.failedGroups === 0) {
            <mat-icon class="result-icon success">check_circle</mat-icon>
            } @else if (saveResult.applied > 0) {
            <mat-icon class="result-icon partial">warning</mat-icon>
            } @else {
            <mat-icon class="result-icon" style="color: #f44336;">error</mat-icon>
            }

            <div class="result-title">
                @if (saveResult.failedGroups === 0) { Carga exitosa }
                @else if (saveResult.applied > 0) { Carga parcial }
                @else { Error en la carga }
            </div>

            <div class="result-detail">
                Se procesaron {{ totalAppliedRows }} cambio(s) del archivo "{{ fileName }}"
            </div>

            <div class="result-stats">
                @if (saveResult.applied > 0) {
                <div class="stat ok">
                    <div class="stat-number">{{ saveResult.applied }}</div>
                    <div class="stat-label">Aplicados</div>
                </div>
                }
                @if (saveResult.failedGroups > 0) {
                <div class="stat fail">
                    <div class="stat-number">{{ saveResult.failedGroups }}</div>
                    <div class="stat-label">Grupos fallidos</div>
                </div>
                }
            </div>

            @if (saveResult.failedDetails.length > 0) {
            <div class="failed-groups-warning">
                <div class="warning-header">
                    <mat-icon>warning</mat-icon>
                    <strong>Grupos que no se pudieron aplicar</strong>
                </div>
                <ul class="warning-list">
                    @for (detail of saveResult.failedDetails; track detail) {
                    <li>{{ detail }}</li>
                    }
                </ul>
            </div>
            }
        </div>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    @if (step === 'upload') {
    <button mat-button (click)="closeDialog()">Cancelar</button>
    }

    @if (step === 'preview') {
    <button mat-button (click)="goBackToUpload()">
        <mat-icon>arrow_back</mat-icon> Atrás
    </button>
    <button mat-raised-button color="primary" (click)="saveChanges()"
        [disabled]="isSaving || validDataSource.data.length === 0">
        <mat-icon>save</mat-icon>
        Aplicar {{ validDataSource.data.length }} cambio(s)
    </button>
    }

    @if (step === 'result') {
    <button mat-raised-button color="primary" (click)="closeDialog(saveResult?.failedGroups === 0)">
        <mat-icon>done</mat-icon> Finalizar
    </button>
    }
</mat-dialog-actions>
